// import React, { useEffect, useState } from "react";
// import "../InfluencerPage/InfluencerPage.css";
// import { InfluencerInfo, InfluencerPasswordUpdate } from "../api/api";
// import moment from "moment";
// import Swal from "sweetalert2";
// import { FiLogOut } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";

// const InfluencerPage = () => {
//   const [user, setUser] = useState(null);
//   const [history, setHistory] = useState([]);
//   const [total, settotal] = useState("");
//   const [password, setPassword] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchUserData = async () => {
//       const storedUser = localStorage.getItem("influencerData");
//       const jwtToken = localStorage.getItem("jwtTokeninfluencer");

//       if (storedUser) {
//         try {
//           const parsedUser = JSON.parse(storedUser);
//           const value = {
//             influencer_id: parsedUser?.id || parsedUser?._id,
//             jwt: jwtToken,
//           };
//           console.log("passInfluencerInfo", value);
//           const response = await InfluencerInfo(value);
//           console.log("influencer_details", JSON.stringify(response));
//           if (!response.success) {
//             Swal.fire({
//               icon: "warning",
//               title: "Session Timeout",
//               text: "Your session has expired. Please log in again.",
//               confirmButtonText: "OK",
//             }).then(() => {
//               navigate("/AffiliateAccess");
//             });
//           } else if (response?.success && response?.data) {
//             setUser(response.data);
//             settotal(response?.totalCommissionByCurrency);
//             if (Array.isArray(response.history)) {
//               setHistory(response.history);
//             }
//           }
//         } catch (error) {
//           console.error("Error parsing user or fetching data:", error);
//         }
//       }
//     };

//     fetchUserData();
//   }, []);

//   const filteredHistory = history.filter((entry) => {
//     const entryDate = moment(entry.updated_at);
//     const isAfterFromDate = fromDate
//       ? entryDate.isSameOrAfter(moment(fromDate).startOf("day"))
//       : true;
//     const isBeforeToDate = toDate
//       ? entryDate.isSameOrBefore(moment(toDate).endOf("day"))
//       : true;
//     return isAfterFromDate && isBeforeToDate;
//   });

//   return (
//     <div className="InfluencerPageMain">
//       {user ? (
//         <div className="history-section">
//           <div className="influencer-form">
//             <div className="influencersection-header">
//               <h2 className="influencersection-title">Your Details</h2>
//               <FiLogOut
//                 className="logout-icon-influncer"
//                 title="Logout"
//                 onClick={() => {
//                   Swal.fire({
//                     title: "Are you sure?",
//                     text: "You will be logged out!",
//                     icon: "warning",
//                     showCancelButton: true,
//                     confirmButtonColor: "#e04a48",
//                     cancelButtonColor: "#058787",
//                     confirmButtonText: "Yes, logout!",
//                   }).then((result) => {
//                     if (result.isConfirmed) {
//                       localStorage.removeItem("influencerData");
//                       localStorage.removeItem("jwtTokeninfluencer");
//                       navigate("/AffiliateAccess");
//                     }
//                   });
//                 }}
//                 style={{ cursor: "pointer", marginLeft: "auto" }}
//               />
//             </div>

//             <div className="labelValueRow">
//               <div className="form-group">
//                 <label>Name *</label>
//                 <input
//                   type="text"
//                   value={user?.name || ""}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Email</label>
//                 <input
//                   type="text"
//                   value={user?.email || ""}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Referral Code</label>
//                 <input
//                   type="text"
//                   value={user?.code || ""}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>
//             </div>
//           </div>
//           <div className="influencer-form">
//             <div className="influencersection-header">
//               <h2 className="influencersection-title">
//                 Total Income From Comission
//               </h2>
//             </div>

//             <div className="labelValueRow">
//               <div className="form-group">
//                 <label>In GBP (£)</label>
//                 <input
//                   type="text"
//                   value={total?.GBP}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>In NGN (₦)</label>
//                 <input
//                   type="text"
//                   value={total?.NGN}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>In USD ($)</label>
//                 <input
//                   type="text"
//                   value={total?.USD}
//                   disabled
//                   style={{ backgroundColor: "#f0f0f0" }}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="history-section">
//             <h1 className="section-title">Referral Code Usage History</h1>

//             <div className="date-filter-container">
//               <label>
//                 From:
//                 <input
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                 />
//               </label>
//               <label>
//                 To:
//                 <input
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                 />
//               </label>
//             </div>

//             {filteredHistory.length > 0 ? (
//               <table className="history-table">
//                 <thead>
//                   <tr>
//                     <th>User Name</th>
//                     <th>User Email</th>
//                     <th>Comission</th>
//                     {/* <th>Used On</th> */}
//                     <th>Subscribed (Yes/No)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredHistory.map((entry, index) => (
//                     <tr key={index}>
//                       <td>{entry.user?.name || "N/A"}</td>
//                       <td>{entry.user?.email || "N/A"}</td>
//                       <td>
//                         {entry?.user?.sign_up_currency_symbol}{" "}
//                         {entry.commission_amount}
//                       </td>
//                       <td>{entry.status === "1" ? "Yes" : "No"}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             ) : (
//               <p className="noReferralText">
//                 No referral history found for selected dates.
//               </p>
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="loadingdiv">
//           <div className="spinner"></div>
//           <p className="loading-text">Loading Influencer info...</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InfluencerPage;

import React, { useEffect, useState } from "react";
import "../InfluencerPage/InfluencerPage.css";
import {
  InfluencerInfo,
  InfluencerPasswordUpdate,
  influencerfilterbydate,
} from "../api/api";
import moment from "moment";
import Swal from "sweetalert2";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/brown-background.jpg";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from "react-icons/fa";

const InfluencerPage = () => {
  const [user, setUser] = useState(null);
  const [history, setHistory] = useState([]);
  const [total, settotal] = useState("");
  const [password, setPassword] = useState("");
  const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");
  const [toDate, setToDate] = useState(() => moment().format("YYYY-MM-DD"));
  const [toDateDisplay, setToDateDisplay] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const influencerData = localStorage.getItem("influencerData");
    if (
      !influencerData ||
      influencerData === null ||
      influencerData === undefined
    ) {
      navigate("/AffiliateAccess", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (fromDate && toDate) {
      filterData();
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    const fetchUserData = async () => {
      const storedUser = localStorage.getItem("influencerData");
      const jwtToken = localStorage.getItem("jwtTokeninfluencer");

      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          const value = {
            influencer_id: parsedUser?.id || parsedUser?._id,
            jwt: jwtToken,
          };
          console.log("passInfluencerInfo", value);
          const response = await InfluencerInfo(value);
          console.log("influencer_details", JSON.stringify(response));
          if (!response.success) {
            Swal.fire({
              icon: "warning",
              title: "Session Timeout",
              text: "Your session has expired. Please log in again.",
              confirmButtonText: "OK",
            })
              // .then(() => {
              //   localStorage.removeItem("influencerData");
              //   localStorage.removeItem("jwtTokeninfluencer");
              //   navigate("/AffiliateAccess");
              // });
              .then((result) => {
                if (result.isConfirmed) {
                  localStorage.removeItem("influencerData");
                  localStorage.removeItem("jwtTokeninfluencer");
                  navigate("/AffiliateAccess");
                }
              });
            // navigate("/AffiliateAccess");
          } else if (response?.success && response?.data) {
            setUser(response.data);
            settotal(response?.totalCommissionByCurrency);
            if (Array.isArray(response.history)) {
              setHistory(response.history);
            }
          }
        } catch (error) {
          console.error("Error parsing user or fetching data:", error);
        }
      }
    };

    fetchUserData();
  }, []);

  const filteredHistory = history.filter((entry) => {
    const entryDate = moment(entry.updated_at);
    const isAfterFromDate = fromDate
      ? entryDate.isSameOrAfter(moment(fromDate).startOf("day"))
      : true;
    const isBeforeToDate = toDate
      ? entryDate.isSameOrBefore(moment(toDate).endOf("day"))
      : true;
    return isAfterFromDate && isBeforeToDate;
  });

  const filterData = async () => {
    try {
      const storedUser = localStorage.getItem("influencerData");
      const parsedUser = JSON.parse(storedUser);
      const value = {
        start_date: fromDate,
        end_date: toDate,
        influencer_id: parsedUser?.id || parsedUser?._id,
      };
      console.log("filter_dates", value);
      const filterDataapi = await influencerfilterbydate(value);
      console.log("api_response", JSON.stringify(filterDataapi));

      if (
        filterDataapi?.success &&
        filterDataapi?.comission_filtered &&
        Array.isArray(filterDataapi?.comission_filtered.history)
      ) {
        setHistory(filterDataapi.comission_filtered.history);
        settotal(filterDataapi.comission_filtered.totalCommissionByCurrency);
      } else {
        setHistory([]);
        settotal({ GBP: 0, NGN: 0, USD: 0 });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div
      className="InfluencerPageMain"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Influencer Page</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Influencer Page
        </p>
      </div>
      <div className="containerall">
        {user ? (
          <div className="history-section">
            <div className="influencer-form">
              <div className="influencersection-header">
                <h2 className="influencersection-title">Your Details</h2>
                <FiLogOut
                  className="logout-icon-influncer"
                  title="Logout"
                  onClick={() => {
                    Swal.fire({
                      title: "Are you sure?",
                      text: "You will be logged out!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#e04a48",
                      cancelButtonColor: "#058787",
                      confirmButtonText: "Yes, logout!",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        localStorage.removeItem("influencerData");
                        localStorage.removeItem("jwtTokeninfluencer");
                        navigate("/AffiliateAccess");
                      }
                    });
                  }}
                  style={{ cursor: "pointer", marginLeft: "auto" }}
                />
              </div>

              <div className="labelValueRow">
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    value={user?.name || ""}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="text"
                    value={user?.email || ""}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>

                <div className="form-group">
                  <label>Referral Code</label>
                  <input
                    type="text"
                    value={user?.code || ""}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>
              </div>
            </div>
            <div className="influencer-form">
              <div className="influencersection-header">
                <h2 className="influencersection-title">
                  Total Income From Comission
                </h2>
              </div>

              <div className="labelValueRow">
                <div className="form-group">
                  <label>In GBP (£)</label>
                  <input
                    type="text"
                    value={total?.GBP}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>

                <div className="form-group">
                  <label>In NGN (₦)</label>
                  <input
                    type="text"
                    value={total?.NGN}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>

                <div className="form-group">
                  <label>In USD ($)</label>
                  <input
                    type="text"
                    value={total?.USD}
                    disabled
                    style={{ backgroundColor: "#f0f0f0" }}
                  />
                </div>
              </div>
            </div>

            <div className="history-section">
              <h1 className="section-title">Referral Code Usage History</h1>
              <div className="date-filter-container">
                <label>
                  From:
                  <input
                    type="date"
                    value={fromDate}
                    max={moment().format("YYYY-MM-DD")}
                    onChange={(e) => {
                      const selectedFrom = e.target.value;
                      if (
                        toDate &&
                        moment(selectedFrom).isAfter(moment(toDate), "day")
                      ) {
                        Swal.fire({
                          icon: "error",
                          title: "Invalid Date",
                          text: "From Date cannot be after To Date.",
                          confirmButtonText: "OK",
                        });
                        return;
                      }

                      setFromDate(selectedFrom);
                      if (selectedFrom && toDate) {
                        filterData();
                      }
                    }}
                  />
                </label>
                <label>
                  To:
                  <input
                    type="date"
                    value={toDate || moment().format("YYYY-MM-DD")}
                    max={moment().format("YYYY-MM-DD")}
                    onChange={(e) => {
                      const selectedTo = e.target.value;
                      if (
                        fromDate &&
                        moment(selectedTo).isBefore(moment(fromDate), "day")
                      ) {
                        Swal.fire({
                          icon: "error",
                          title: "Invalid Date",
                          text: "To Date cannot be before From Date.",
                          confirmButtonText: "OK",
                        });
                        return;
                      }

                      setToDate(selectedTo);
                      if (fromDate && selectedTo) {
                        filterData();
                      }
                    }}
                  />
                </label>
              </div>
              <div className="history-tablemain">
                {history.length > 0 ? (
                  <table className="history-table">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>User Email</th>
                        <th>Comission</th>
                        <th>Subscribed (Yes/No)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.map((entry, index) => (
                        <tr key={index}>
                          <td>{entry.user?.name || "N/A"}</td>
                          <td>{entry.user?.email || "N/A"}</td>
                          <td>
                            {entry?.user?.sign_up_currency_symbol}{" "}
                            {entry.commission_amount}
                          </td>
                          <td>{entry.status === "1" ? "Yes" : "No"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="noReferralText">
                    No referral history found for selected dates.
                  </p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="loadingdiv">
            <div className="spinner"></div>
            <p className="loading-text">Loading Influencer info...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfluencerPage;
